import React from "react";

import {
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Button
} from "@mui/material";

export default function RateTable({ rates, onDelete }) {

  /* =========================
     ⭐ SAFETY FIX
     Ensure rates is always an array
  ========================= */

  const safeRates = Array.isArray(rates) ? rates : [];

  return (

    <Table>

      <TableHead>

        <TableRow>

          <TableCell>Client</TableCell>
          <TableCell>Project</TableCell>
          <TableCell>User</TableCell>
          <TableCell>Role</TableCell>
          <TableCell>Rate</TableCell>
          <TableCell>Currency</TableCell>
          <TableCell>Effective From</TableCell>
          <TableCell>Actions</TableCell>

        </TableRow>

      </TableHead>

      <TableBody>

        {safeRates.length === 0 ? (

          <TableRow>
            <TableCell colSpan={8} align="center">
              No billing rates found
            </TableCell>
          </TableRow>

        ) : (

          safeRates.map((r) => (

            <TableRow key={r.id}>

              <TableCell>{r.client}</TableCell>
              <TableCell>{r.project}</TableCell>
              <TableCell>{r.user || "-"}</TableCell>
              <TableCell>{r.role || "-"}</TableCell>
              <TableCell>{r.rate}</TableCell>
              <TableCell>{r.currency}</TableCell>
              <TableCell>{r.effective_from}</TableCell>

              <TableCell>

                <Button
                  color="error"
                  onClick={() => onDelete(r.id)}
                >
                  Delete
                </Button>

              </TableCell>

            </TableRow>

          ))

        )}

      </TableBody>

    </Table>

  );

}